/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'youtube': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M21.37 6.498c.456 1.782.456 5.502.456 5.502s0 3.72-.457 5.502c-.254.985-.997 1.76-1.938 2.022-1.709.476-7.605.476-7.605.476s-5.893 0-7.605-.476c-.945-.266-1.687-1.04-1.938-2.022C1.826 15.72 1.826 12 1.826 12s0-3.72.457-5.502c.254-.985.997-1.76 1.938-2.022C5.933 4 11.826 4 11.826 4s5.896 0 7.605.476c.945.266 1.687 1.04 1.938 2.022zM9.825 15.5l6-3.5-6-3.5v7z" _fill="#81899D"/>'
  }
})
